import React, { FC } from 'react';
import styles from './styles.module.css';
import cx from 'classnames';
import { translations } from '../strings';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';

type Props = {};

const FeedbackTab: FC<Props> = () => {
  const {
    locale,
    setFeedbackState,
    useLightBackground,
    tabPosition,
    hiddenTab,
    customFeedbackId,
    setHidingTab,
    hidingTab
  } = usePublicFeedbackState();
  const strings = translations(locale);

  const handleOnClick = () => {
    setHidingTab(true);
    setTimeout(() => {
      setFeedbackState('TYPE');
    }, 300);
  };

  return (
    <div
      className={cx(styles.feedbackTabOuter, {
        [styles.lightBackgroundTab]: useLightBackground,
        [styles.bottomRight]: tabPosition === 'bottom-right',
        [styles.bottomLeft]: tabPosition === 'bottom-left',
        [styles.topRight]: tabPosition === 'top-right',
        [styles.topLeft]: tabPosition === 'top-left',
        [styles.hiddenTab]: hiddenTab || customFeedbackId,
        [styles.hidingTab]: hidingTab
      })}
      onClick={handleOnClick}
    >
      {strings.tab_text}
    </div>
  );
};

export default FeedbackTab;
